(function () {
  'use strict';

  if (window.MaisonHeader) return;

  var focusableSelector = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function initDesktopHeader(header) {
    if (!header || header.dataset.maisonInitialized === 'true') return;
    header.dataset.maisonInitialized = 'true';
    header.classList.add('is-scroll-managed');

    var variant = header.dataset.maisonHeaderVariant;
    var legacyClass = variant ? 'menu_scroll_v' + variant : '';
    var ticking = false;
    var isHomeHeader = header.classList.contains('homepage');
    var lastScrollY = Math.max(0, window.scrollY);
    var direction = null;
    var distance = 0;
    var showThreshold = 18;
    var hideThreshold = 10;

    function setVisible(visible) {
      header.classList.toggle('is-visible', visible);
      header.setAttribute('data-maison-header-visible', visible ? 'true' : 'false');
    }

    function update(force) {
      ticking = false;

      var currentScrollY = Math.max(0, window.scrollY);
      var delta = currentScrollY - lastScrollY;
      var topZone = isHomeHeader
        ? Math.max(96, Math.round(header.offsetHeight * 0.8))
        : 8;
      var pastTopZone = currentScrollY > topZone;

      header.classList.toggle('is-scrolled', pastTopZone);
      if (legacyClass) header.classList.toggle(legacyClass, pastTopZone);

      if (!pastTopZone) {
        setVisible(!isHomeHeader);
        direction = null;
        distance = 0;
      } else if (!force && Math.abs(delta) >= 1) {
        var nextDirection = delta > 0 ? 'down' : 'up';

        if (nextDirection !== direction) {
          direction = nextDirection;
          distance = 0;
        }

        distance += Math.abs(delta);

        if (direction === 'down' && distance >= hideThreshold) {
          setVisible(false);
          distance = 0;
        } else if (direction === 'up' && distance >= showThreshold) {
          setVisible(true);
          distance = 0;
        }
      }

      lastScrollY = currentScrollY;
    }

    function requestUpdate(force) {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update(force);
      });
    }

    update(true);

    window.addEventListener('scroll', function () {
      requestUpdate(false);
    }, { passive: true });

    window.addEventListener('resize', function () {
      requestUpdate(true);
    }, { passive: true });
  }

  function initMobileHeader(header) {
    if (!header || header.dataset.maisonInitialized === 'true') return;
    header.dataset.maisonInitialized = 'true';

    var ticking = false;
    function update() {
      ticking = false;
      header.classList.toggle('is-scrolled', window.scrollY > header.offsetHeight);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.maisonInitialized === 'true') return;
    drawer.dataset.maisonInitialized = 'true';

    var trigger = document.querySelector('[data-maison-drawer-trigger]');
    var closeButton = drawer.querySelector('[data-maison-drawer-close]');
    var overlay = document.querySelector('.box_contentmenu_background');
    var wasOpen = drawer.classList.contains('active');

    function focusableElements() {
      return Array.prototype.filter.call(drawer.querySelectorAll(focusableSelector), function (element) {
        return element.offsetParent !== null && element.getAttribute('aria-hidden') !== 'true';
      });
    }

    function sync(open, restoreFocus) {
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('activemenu_mobile', open);
      if (overlay) overlay.classList.toggle('active', open);
      if ('inert' in drawer) drawer.inert = !open;

      drawer.querySelectorAll('[data-maison-submenu-toggle]').forEach(function (button) {
        var parent = button.closest('.menu-horizon-list');
        button.setAttribute('aria-expanded', parent && parent.classList.contains('active') ? 'true' : 'false');
      });

      if (open && !wasOpen && closeButton) closeButton.focus();
      if (!open && wasOpen && restoreFocus && trigger) trigger.focus();
      wasOpen = open;
    }

    function open() {
      drawer.classList.add('active');
      sync(true, false);
    }

    function close(restoreFocus) {
      drawer.classList.remove('active');
      sync(false, restoreFocus);
    }

    trigger.addEventListener('click', open);
    if (closeButton) closeButton.addEventListener('click', function () { close(true); });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }
      if (event.key !== 'Tab') return;

      var elements = focusableElements();
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var observer = new MutationObserver(function () {
      sync(drawer.classList.contains('active'), true);
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    drawer.querySelectorAll('.menu-horizon-list').forEach(function (item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    sync(wasOpen, false);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-maison-header]').forEach(initDesktopHeader);
    (root || document).querySelectorAll('[data-maison-mobile-header]').forEach(initMobileHeader);
    (root || document).querySelectorAll('[data-maison-mobile-drawer]').forEach(initDrawer);
  }

  window.MaisonHeader = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();